exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-sidenav {\n  padding: 20px;\n  border-radius: 1px; }\n\nbody {\n  background-color: white; }\n\nmat-icon {\n  left: 0;\n  margin-left: 0; }\n\nbutton.subButton {\n  background: white;\n  color: #607D8B; }\n\n.teste {\n  max-width: 250px;\n  width: 180px;\n  text-align: left;\n  color: white; }\n\n/* p, button{\r\n    max-width: 250px;\r\n    width: 250px;\r\n    text-align: left;\r\n    background: #00754A;\r\n    color: white;\r\n    border-radius: 5px;\r\n  } */\nspan {\n  font-size: 15px; }\n\nimg {\n  max-width: 80px;\n  max-height: 80px;\n  width: auto;\n  height: auto; }\n\n.mat-expansion-panel:not([class*=mat-elevation-z]) {\n  /* box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12); */\n  box-shadow: none !important; }\n\n.mat-expansion-panel {\n  background: none !important;\n  color: rgba(0, 0, 0, 0.87); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/sidenav-solicitacao/sidenav-solicitacao.component.scss
// module id = ../../../../../src/app/components/sidenav-solicitacao/sidenav-solicitacao.component.scss
// module chunks = main